import { Steps } from "../onboarding/types";
import { FlowConfig } from "./types";
import { obesityFlow } from "./obesity";
import { obesityLandingVariantFlow } from "./obesityLandingVariant";
import { hypertensionFlow } from "./hypertension";
export const flowRegistry: Record<string, FlowConfig> = {
  obesity: obesityFlow,
  obesityLandingVariant: obesityLandingVariantFlow,
  hypertension: hypertensionFlow,
};

export const getFlowConfig = (flowId?: string): FlowConfig | undefined => {
  if (!flowId) return undefined;
  return flowRegistry[flowId];
};

export const getFlowForStep = (stepId: string): FlowConfig | undefined => {
  return Object.values(flowRegistry).find((flow) => stepId in flow.steps);
};

export const getAllSteps = (): Steps => {
  const allSteps: Steps = {};
  for (const flow of Object.values(flowRegistry)) {
    Object.assign(allSteps, flow.steps);
  }
  return allSteps;
};
